import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-header-brand-logo.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSHeaderBrandLogo = props => {
  const {
    imgSrc,
    href,
    altText,
    analytics
  } = props;
  // Tests have been written for this code, but it's still showing as uncovered, so we're ignoring it for the coverage.
  /* istanbul ignore next */
  return jsx("a", {
    className: getClassNameList('uitk-header-brand-logo'),
    href: href || '/',
    "data-testid": "header-brand-logo-anchor",
    onClickCapture: analytics && analyticsTracker.bind(undefined, analytics),
    children: jsx("img", {
      src: imgSrc,
      alt: altText
    })
  });
};
EGDSHeaderBrandLogo.displayName = 'EGDSHeaderBrandLogo';
export { EGDSHeaderBrandLogo };